import Commons from '../../../../Services/Common/Common';

export const REV_BASIC_Schema = {
  fields: {
    title: { initial: '', label: '제목', required: 'Y', requiredWhen: 'ALL' },
  },
  mapper: {
    search1: {},
    search4: {},
    search2: {
      CoCd: (_, context) => Commons.EncryptAES(String(context.CoCd ?? '')),
      Category: (_, context) => Commons.EncryptAES(String(context.Category ?? '')),
      Status: (_, context) => Commons.EncryptAES(String(context.Status ?? '')),
      SearchText: (_, context) =>
        Commons.EncryptAES(String(context.SearchText ?? '')),
      StartDate: (_, context) => Commons.EncryptAES(String(context.StartDate ?? '')),
      EndDate: (_, context) => Commons.EncryptAES(String(context.EndDate ?? '')),
    },
    search3: {
      ReqSeq: (_, context) => Commons.EncryptAES(String(context.ReqSeq ?? '')),
    },
    save1: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      CoCd: (row) => Commons.EncryptAES(String(row.coCd ?? '')),
      Title: (row) => Commons.EncryptAES(String(row.title ?? '')),
      Content: (row) => Commons.EncryptAES(String(row.content ?? '')),
      Category: (row) => Commons.EncryptAES(String(row.category ?? '')),
      PriorityLvl: (row) => Commons.EncryptAES(String(row.priority ?? 'P2')),
      Status: (row) => Commons.EncryptAES(String(row.status ?? '시작전')),
      AssigneeId: (row) => Commons.EncryptAES(String(row.assigneeId ?? '')),
      DueDate: (row) => Commons.EncryptAES(String(row.dueDate ?? '')),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    delete1: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    saveFile2: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      FileName: (row) => Commons.EncryptAES(String(row.fileName ?? '')),
      FilePath: (row) => Commons.EncryptAES(String(row.filePath ?? '')),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    deleteFile1: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      FileSeq: (row) => Commons.EncryptAES(String(row.fileSeq ?? 0)),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    saveActivity3: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      Comment: (row) => Commons.EncryptAES(String(row.comment ?? '')),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
    deleteActivity1: {
      ReqSeq: (row) => Commons.EncryptAES(String(row.reqSeq ?? 0)),
      ActSeq: (row) => Commons.EncryptAES(String(row.actSeq ?? 0)),
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
